import React, { useState, useRef, useEffect } from 'react';
import './TableActionsMenu.css';

const PrintIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
    <path d="M7 9V4h10v5M7 18H5a2 2 0 01-2-2v-5a2 2 0 012-2h14a2 2 0 012 2v5a2 2 0 01-2 2h-2" strokeLinecap="round" />
    <path d="M7 14h10v6H7v-6z" strokeLinejoin="round" />
  </svg>
);

const ExcelIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <rect x="4" y="3" width="16" height="18" rx="2" fill="#217346" />
    <path d="M8 8l3 4-3 4M13 16h3" stroke="#fff" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const FilterIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
    <path d="M4 6h16M7 12h10M10 18h4" strokeLinecap="round" />
  </svg>
);

export default function TableActionsMenu({ onExport, onPrint, onFilter, variant = 'menu' }) {
  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleExport = () => {
    onExport?.();
    setOpen(false);
  };

  const handlePrint = () => {
    onPrint?.();
    setOpen(false);
  };

  const handleFilter = () => {
    onFilter?.();
    setOpen(false);
  };

  if (variant === 'report') {
    return (
      <div className="table-actions-bar">
        <button
          type="button"
          className="report-action-btn report-action-btn--print report-action-btn--icon"
          onClick={handlePrint}
          data-tooltip="הדפסה"
          aria-label="הדפסה"
        >
          <PrintIcon />
        </button>
        <button
          type="button"
          className="report-action-btn report-action-btn--export report-action-btn--icon"
          onClick={handleExport}
          data-tooltip="יצא לאקסל"
          aria-label="יצא לאקסל"
        >
          <ExcelIcon />
        </button>
        {onFilter && (
          <button
            type="button"
            className="report-action-btn report-action-btn--filter report-action-btn--icon"
            onClick={handleFilter}
            data-tooltip="סנן"
            aria-label="סנן"
          >
            <FilterIcon />
          </button>
        )}
      </div>
    );
  }

  return (
    <div className="table-actions-menu" ref={menuRef}>
      <button
        type="button"
        className="table-actions-trigger"
        onClick={() => setOpen((prev) => !prev)}
        title="פעולות"
        aria-label="פעולות"
        aria-expanded={open}
      >
        ⋮
      </button>
      {open && (
        <div className="table-actions-dropdown">
          <button type="button" className="table-actions-item" onClick={handleExport}>
            יצא לאקסל
          </button>
          <button type="button" className="table-actions-item" onClick={handlePrint}>
            הדפס
          </button>
        </div>
      )}
    </div>
  );
}
